/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GynaecHistory from './gynaec-history';
import GynaecHistoryDetail from './gynaec-history-detail';
import GynaecHistoryUpdate from './gynaec-history-update';
import GynaecHistoryDeleteDialog from './gynaec-history-delete-dialog';

const GynaecHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GynaecHistory />} />
    <Route path="new" element={<GynaecHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<GynaecHistoryDetail />} />
      <Route path="edit" element={<GynaecHistoryUpdate />} />
      <Route path="delete" element={<GynaecHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GynaecHistoryRoutes;
